export default "__VITE_ASSET__b9329f9a__"